import type { DocumentAuditTrailModel } from "@/api/cle-api";

import { AuditTrailFieldChanges } from "./AuditTrailFieldChanges";
import { getAuditTrailEventConfig } from "./utils/auditTrailConfig";
import { getAuditTrailFieldChanges } from "./utils/formatAuditTrailFieldChange";
import { formatAuditTrailSummary } from "./utils/formatAuditTrailSummary";
import { formatAuditTrailActor } from "./utils/formatters";
import { formatAuditTrailTimestamp } from "./utils/formatAuditTrailTimestamp";

interface AuditTrailTimelineItemProps {
  item: DocumentAuditTrailModel;
  isLast: boolean;
}

export const AuditTrailTimelineItem = ({
  item,
  isLast,
}: AuditTrailTimelineItemProps) => {
  const config = getAuditTrailEventConfig(item.action);
  const { relative, absolute } = formatAuditTrailTimestamp(item.createdAt);
  const actor = formatAuditTrailActor(item);
  const fieldChanges = getAuditTrailFieldChanges(item.details?.fieldChanges);
  const summary = formatAuditTrailSummary(item);

  return (
    <li className={`audit-trail__item d-flex gap-3${isLast ? "" : " pb-4"}`}>
      <div className="audit-trail__marker flex-shrink-0 position-relative">
        <span
          className={`audit-trail__icon audit-trail__icon--${config.iconVariant}`}
        >
          {config.icon}
        </span>
      </div>
      <div className="flex-grow-1 pt-1" style={{ minWidth: 0 }}>
        <div className="d-flex align-items-center flex-wrap gap-2">
          <span
            className={`badge rounded-pill fw-semibold ${config.badgeClassName}`}
          >
            {config.label}
          </span>
          <span className="text-muted small">
            {relative} · {absolute}
          </span>
        </div>
        <p className="text-muted small mb-0 mt-1 ">
          Udført af: <span className="fw-semibold text-body">{actor}</span>
        </p>
        {summary ? (
          <p className="text-muted small mb-0 mt-1 text-break">{summary}</p>
        ) : null}
        <AuditTrailFieldChanges fieldChanges={fieldChanges} />
      </div>
    </li>
  );
};
